import { PropsWithChildren } from 'react';
import { ListItem as MuiListItem, ListItemProps as MuiListItemProps } from '@mui/material';

export type ListItemProps = PropsWithChildren &
  MuiListItemProps & {
    flex?: boolean | string;
    layout?: 'row' | 'column';
    'layout-align'?: string;
    'layout-padding'?: boolean;
  };

export const ListItem: React.FC<ListItemProps> = ({ children, flex, layout = 'row', ...boxProps }) => {
  const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, sx, ...props } = boxProps;
  const align = layoutAlign?.split(' ');
  const justifyContent = align?.[layout === 'row' ? 0 : 1];
  const alignItems = align?.[layout === 'row' ? 1 : 0];

  return (
    <MuiListItem
      sx={{
        display: !!flex || layoutAlign ? 'flex' : undefined,
        flex: typeof flex === 'string' ? flex : undefined,
        justifyContent,
        alignItems,
        padding: layoutPadding ? '16px' : undefined,
        ...sx,
      }}
      disableGutters
      disablePadding
      {...props}
    >
      {children}
    </MuiListItem>
  );
};
